import React, { Component } from 'react';
import Select from 'react-select';
import InputField from './../../elements/InputField';
// import CheckBox from './../../elements/CheckBox';//need to remove
// import Radiobox from './../../elements/Radiobox';//need to remove
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import CheckBox from "./../../elements/CheckBox";
import { REACT_APP_TENANT } from '../../../config/constant';
class SearchDealer extends Component {
  constructor(props) {
    super(props);
    this.handleChangetext = this.handleChangetext.bind(this);
    this.state = {
      filterData: {
      },
      keyword:""
    };
  }


  handleChangetext = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }
  handleOptionChange = (sname, ovalue) => {
        let filterData = this.state.filterData;
    if(sname === 'relation_dealer'){
      filterData[sname] = (ovalue.code != null) ? ovalue.code : ovalue.target.code;
    }else{
      filterData[sname] = (ovalue.value != null) ? ovalue.value : ovalue.target.value;
    }

    let keyword = "";
    if(sname === 'search_text'){
      keyword = ovalue.target.value;
    }
    this.setState({ filterData, keyword });
    if (typeof this.props.optionChange === 'function') {
      this.props.optionChange(sname, ovalue);
    }

  }
  handlechecked = (keyname) => event =>{
    let checkvalue='';
    if(event.target.checked){
        checkvalue=event.target.value;       
    }else{
        checkvalue='';        
    } 
    if (typeof this.props.handlechecked === 'function') {
        this.props.handlechecked(keyname, checkvalue);
    } 
    let updatedState = this.state.filterData
    updatedState[keyname] = checkvalue
    console.log("################",updatedState);
    this.setState({filterData: updatedState})

}
  handleCityOptionChange = (sname, ovalue) => {
    let filterData = this.state.filterData;
    filterData[sname] = (ovalue.id != null) ? ovalue.id : ovalue.target.id;
    this.setState({ filterData });
    if (typeof this.props.optionCityChange === 'function') {
      this.props.optionCityChange(sname, ovalue);
    }

  }

  handleStateOptionChange = (sname, ovalue) => {
    let filterData = this.state.filterData;
    filterData[sname] = (ovalue.id != null) ? ovalue.id : ovalue.target.id;
    this.setState({ filterData });
    if (typeof this.props.optionStateChange === 'function') {
      this.props.optionStateChange(sname, ovalue);
    }
  }

  handleSkuOptionChange = (sname, ovalue) => {
    let filterData = this.state.filterData;
    filterData[sname] = (ovalue.sku_short_name != null) ? ovalue.sku_short_name : ovalue.target.sku_short_name;
    this.setState({ filterData });
    if (typeof this.props.optionSkuChange === 'function') {
      this.props.optionSkuChange(sname, ovalue);
    }

  }

  handlePremiumChange = (sname, ovalue) => {
    let filterData = this.state.filterData;
    filterData[sname] = (ovalue.code) != null ? ovalue.code : ovalue.target.code;
    this.setState({ filterData })
    if (typeof this.props.optionPremiumChange === 'function') {
      this.props.optionPremiumChange(sname, ovalue);
    }
  }

  componentWillMount() {
    if (sessionStorage.getItem('userData')) {
      this.setState({ redirect: true })
    }
  }
  submitFilterForm = (event) => {
    event.preventDefault();
    if (typeof this.props.onSubmitFilter === 'function') {
      this.props.onSubmitFilter(event);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.searchByList && nextProps.searchByList[0] && !this.state.filterData.search_by) {
      this.handleOptionChange("search_by", { value: nextProps.searchByList[0].value })
    }
  }
  
  resetFilterForm = (event) => {
    window.location.reload(false); 
  }
  render() {
    // const { searchByList, cityAllList, dcSkusList, dealerCountStatusDetail } = this.props; //need to remove
    const { searchByList, cityAllList, dcSkusList, stateAllList } = this.props;
    const { filterData } = this.state;
    return (
      <div className="search-wrap">
        <form onSubmit={this.submitFilterForm}>
        <div className="row">
          <div className="col-sm-2 col-md-2">
          <label>{this.props.t('Listing.Search_Dealer.Search_By')}</label>
            <Select
              components={{ IndicatorSeparator:() => null }}
              id="search_by"
              // value={filterData.search_by}
              onChange={this.handleOptionChange.bind(this, 'search_by')}
              options={searchByList}
              name="search_by"
              placeholder={this.props.t('Listing.Search_Dealer.Search_By_Placeholder')}
              value={searchByList.filter(({ value }) => value === filterData.search_by)}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
            />
          </div>

          <div className="col-sm-2 col-md-2">
            <InputField
              inputProps={{
                id: "search_text",
                type: "text",
                placeholder: this.props.t('Listing.Search_Dealer.Enter_Keyword_Placeholder'),
                name: "search_text",
                autocompleate: "off",
                label: this.props.t('Listing.Search_Dealer.Enter_Keyword_Label'),
                value: this.state.keyword
              }}
              onChange={this.handleOptionChange.bind(this, 'search_text')}
            />
          </div>
          <div className="col-sm-2 col-md-2">
          <label>{this.props.t('Listing.Search_Dealer.State')}</label>
            <Select
              components={{ IndicatorSeparator:() => null }}
              id="state_id"
              onChange={this.handleStateOptionChange.bind(this, 'state_id')}
              options={stateAllList}
              name="state_id"
              placeholder={this.props.t('Listing.Search_Dealer.State_Placeholder')}
              value={stateAllList && stateAllList.length && stateAllList.filter(({ id }) => id === filterData.state_id)}
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
            />
          </div>

          <div className="col-sm-2 col-md-2">
          <label>{this.props.t('Listing.Search_Dealer.City')}</label>
            <Select
              components={{ IndicatorSeparator:() => null }}
              id="city_id"
              // value={filterData.city_id}
              onChange={this.handleCityOptionChange.bind(this, 'city_id')}
              options={cityAllList}
              name="city_id"
              placeholder={this.props.t('Listing.Search_Dealer.City_Placeholder')}
              value={cityAllList && cityAllList.length && cityAllList.filter(({ id }) => id === filterData.city_id)}
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
            />
          </div>

          <div className="col-sm-2 col-md-2">
            <label>{this.props.t('Listing.Search_Dealer.Search_By_Sku')}</label>
            <Select
              components={{ IndicatorSeparator:() => null }}
              id="dc_skus_id"
              // value={filterData.sku_short_name}
              onChange={this.handleSkuOptionChange.bind(this, 'sku_short_name')}
              options={dcSkusList}
              name="dc_skus_id"
              placeholder={this.props.t('Listing.Search_Dealer.Search_By_Sku_Placeholder')}
              value={dcSkusList && dcSkusList.length && dcSkusList.filter(({ sku_short_name }) => sku_short_name === filterData.sku_short_name)}
              getOptionLabel={({ sku_name }) => sku_name}
              getOptionValue={({ sku_short_name }) => sku_short_name}
            />
          </div>

            <div className="col-sm-2 col-md-2">
              <label>{this.props.t('dealerDetails.Basic_Employee_Details.premium_type')}</label>
              <Select
                components={{ IndicatorSeparator:() => null }}
                id="premium_code"
                options={this.props.dealerPremiumTypeList}
                value={this.props.dealerPremiumTypeList.filter(({ code }) => code === filterData.premium_type)}
                onChange={this.handlePremiumChange.bind(this, 'premium_type')}
                name="premium_type"
                placeholder={this.props.t('dealerDetails.Basic_Employee_Details.premium_type_placeholder')}
                getOptionLabel={({ title }) => title}
                getOptionValue={({ code }) => code}
              />
            </div>

        </div>
        <div className="row">
        <div className="col-sm-3 col-md-2" style={{"paddingLeft": "5px","marginBottom": "18px"}}>
              <label>{this.props.t('dealerDetails.Basic_Employee_Details.relation_dealer')}</label>
              <Select
                components={{ IndicatorSeparator:() => null }}
                id="relation_dealer"
                options={this.props.dealerRelationship}
                onChange={this.handleOptionChange.bind(this, 'relation_dealer')}
                name="relation_dealer"
                placeholder={this.props.t('dealerDetails.Basic_Employee_Details.relation_dealer_placeholder')}
                getOptionLabel={({ title }) => title}
                getOptionValue={({ code }) => code}
              />
        </div>
        <div className="col-sm-3 col-md-2" style={{"paddingLeft": "5px","marginBottom": "18px"}}>
              <label>{this.props.t('dealerDetails.Basic_Employee_Details.document_verification_status')}</label>
              <Select
                components={{ IndicatorSeparator:() => null }}
                id="document_verification_status"
                options={[{value:'1',name:"Verified"},{value:'0',name:"Non-Verified"}]}
                onChange={this.handleOptionChange.bind(this, 'document_verification_status')}
                name="document_verification_status"
                placeholder={this.props.t('dealerDetails.Basic_Employee_Details.document_verification_status')}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ value }) => value}
              />
        </div>
        <div className="col-sm-3 col-md-2" style={{"paddingLeft": "5px","marginBottom": "18px"}}>
              <label>{this.props.t('dealerDetails.Basic_Employee_Details.survey_status')}</label>
              <Select
                components={{ IndicatorSeparator:() => null }}
                id="survey_status"
                options={[{value:'1',name:"Surveyed"},{value:'0',name:"Not Surveyed"}]}
                onChange={this.handleOptionChange.bind(this, 'survey_status')}
                name="survey_status"
                placeholder={this.props.t('dealerDetails.Basic_Employee_Details.survey_status')}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ value }) => value}
              />
        </div>
        {/* <div className="col-sm-3 col-md-1" style={{"paddingLeft": "5px","marginBottom": "18px"}}>
        <label></label>
          <CheckBox type="checkbox" name="if_configured" id="if_configured" value="1" label="IF Configured" onChange={this.handlechecked('if_configured')} />   
        </div> */}
        <div className="col-sm-3 col-md-2" style={{"paddingLeft": "15px","marginBottom": "18px",top: "10px","position": "relative"}}>
        <label></label>
        {  ["fav-id"].includes(REACT_APP_TENANT) ? '': <CheckBox type="checkbox" name="if_active" id="if_active" value="1" label="IF Active"  onChange={this.handlechecked('if_active')}/>}
        </div>
        <div className="col-sm-3 col-md-4">
            <label></label>
            <div> 
            <button type="submit" className="btn btn-primary mrg-r10">{this.props.t('Listing.Search_Dealer.Search')}</button>
            <button type="reset" className="btn btn-default" onClick={this.resetFilterForm}>{this.props.t('Listing.Search_Dealer.Reset')}</button>
            </div>
          </div>
        </div>
        </form>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
      auth_token: state.authToken,
      user_loggedin: state.userLoggedIn,
      dealer_id: state.dealer_id
  };
}

const mapDispatchToProps = dispatch => {
  return {
      updateStateIntoRedux: (actionType, stateData) => dispatch({ type: actionType, componentState: stateData })
  }
}
export default withTranslation('dealers')(connect(mapStateToProps, mapDispatchToProps)(SearchDealer));
//export default SearchDealer;
